import { useQuery } from "react-query";
import { warehousesService } from "../services/warehouses.service";

export function useWarehousesAsSelectOptionsQuery() {
  return useQuery(["warehouses-options"], () =>
    warehousesService.getWarehousesAsSelectOptions()
  );
}
